import { filtersReducers } from "./filters";
import { paginationReducers } from "./pagination";
import { selectionReducers } from "./selection";
import { uiReducers } from "./ui";

export const cartReducers = {
  ...filtersReducers,
  ...selectionReducers,
  ...paginationReducers,
  ...uiReducers,
};
